import * as React from 'react';

import $ from 'jquery';
import PropTypes from 'prop-types';

import CreditCardPreferenceInputRow from 'bundles/account-settings/components/sections/payment-method/CreditCardPreferenceInputRow';
import { UserPreferenceKeys } from 'bundles/account-settings/constants/UserPreferences';
import { getUserPreference } from 'bundles/account-settings/utils/UserPreferenceUtils';

import _t from 'i18n!nls/account-settings';

const PREFERENCE_CONFIGS = [
  {
    prefName: 'saveCreditCard',
    get label() {
      return _t('Use this credit card for future purchases');
    },
    get labelWithinCardForm() {
      return _t('Save your credit card for future purchases');
    },
    get helpLabel() {
      return _t(
        `Saves your credit card information so you don't have to enter it again
      on your future purchases. This is the credit card used for subscriptions.`
      );
    },
  },
];

class CreditCardPreferenceInputRows extends React.Component {
  static propTypes = {
    paymentPreferences: PropTypes.object.isRequired,
  };

  render() {
    // TODO(jnam) handle labelWithinCardForm

    return (
      <div className="rc-CreditCardPreferenceInputRows">
        {PREFERENCE_CONFIGS.map((config) => (
          <CreditCardPreferenceInputRow
            key={`pref_${config.prefName}`}
            prefName={config.prefName}
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'paymentPreferences' does not exist on ty... Remove this comment to see the full error message
            isChecked={this.props.paymentPreferences[config.prefName] || false}
            label={config.label}
            helpLabel={config.helpLabel}
          />
        ))}
      </div>
    );
  }
}

class CreditCardPreferenceInputRowsDataProvider extends React.Component {
  state = {
    hasMounted: false,
    paymentPreferences: null,
  };

  componentDidMount() {
    getUserPreference(UserPreferenceKeys.PAYMENT).then((paymentPreferences) =>
      this.setState({ paymentPreferences, hasMounted: true })
    );
  }

  render() {
    if (!this.state.hasMounted) {
      return false;
    } else {
      return <CreditCardPreferenceInputRows {...this.props} paymentPreferences={this.state.paymentPreferences} />;
    }
  }
}

// @ts-expect-error ts-migrate(2339) FIXME: Property 'getFormData' does not exist on type 'typ... Remove this comment to see the full error message
CreditCardPreferenceInputRowsDataProvider.getFormData = () => {
  const formData = {};
  PREFERENCE_CONFIGS.forEach((config) => {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    formData[config.prefName] = $(`.rc-CreditCardPreferenceInputRows input[name="prefinput-${config.prefName}"]`).is(
      ':checked'
    );
  });
  return formData;
};

export default CreditCardPreferenceInputRowsDataProvider;
